
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/what-is-ftl-vs-ltl",
      function () {
        return require("private-next-pages/content/what-is-ftl-vs-ltl.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/what-is-ftl-vs-ltl"])
      });
    }
  